import { getData, isValid } from 'clients/Clients';
import VideoClient from 'clients/VideoClient';
import { useEffect, useState } from 'react';

export const useGetDashboardRedirectAction = ({ isSkip }: { isSkip?: boolean }) => {
  const [isLiveStream, setIsLiveStream] = useState(false);
  useEffect(() => {
    if (isSkip) return;

    const checkIsLivestream = async () => {
      try {
        const response = await VideoClient.getCurrentLiveStream();
        if (!isValid(response)) {
          setIsLiveStream(false);
        }

        const livestream = getData(response);
        if (!livestream?.length) setIsLiveStream(false);

        const currentLive = livestream[0];
        // check if the livestream is live
        setIsLiveStream(!!currentLive?.liveStreamID);
      } catch (error) {
        setIsLiveStream(false);
      }
    };
    checkIsLivestream();
  }, [isSkip]);

  return {
    isLiveStream,
  };
};
